import React from 'react';
import styled from 'styled-components/macro';

interface Props {
  children: any;
  className?: string;
  onClick?: any;
}

const AllSelector = ({ children, className, onClick }: Props) => (
  <StyledAllSelector onClick={onClick} className={className}>
    {children}
  </StyledAllSelector>
);

export default AllSelector;

const StyledAllSelector = styled.button`
  font-size: 0.875rem;
  //text-decoration: underline;
  cursor: pointer;
  color: ${p => p.theme.gray600};
   border: 1px solid ${p => p.theme.gray400};
   padding: 0 0.5rem;

  // &:hover {
  //   background-color: ${p => p.theme.hover};
  // }

  //align-self: center;
  //@media (min-width: 1024px) {
  //  align-self: start;
  //}
`;
